module.exports = __webpack_public_path__ + "static/media/MDSSyllabus.8b946bf6.docx";